<template>
  <b-container fluid class="headerPushDown ">
    <b-container v-if="getSelectedItem" class=" ml-auto mr-auto pl-2 pr-2">


      <b-row>
        <b-col sm="12" md="6">
          <shop-voucher-template-selector
            v-if="hasTeamplatesItems"
            v-bind:VoucherTemplatesData="getVoucherTemplatesData"
            v-bind:getSelectedItem="getSelectedItem"/>

          <shop-voucher-template-preview v-bind:getSelectedItem="getSelectedItem"/>

          <shop-voucher-custom-message-form v-if="isCustomTextEnabled" v-bind:getSelectedItem="getSelectedItem"/>
        </b-col>

        <b-col sm="12" md="6" class="pr-0 pr-md-5">
          <shop-voucher-description-panel v-bind:getSelectedItem="getSelectedItem"/>

          <shop-voucher-service-selection v-bind:getSelectedItemId="getSelectedItemId"/>

          <div class="mt-3 ml-3" v-if="getSelectedItem.allowRequestShipping">
            <b-form-checkbox v-model="getSelectedItem.requestShipping" >Zustellung anfordern</b-form-checkbox>
          </div>

          <b-button @click="addToCart" class="mt-4 text-uppercase" size="md" variant="light"  style="float: right;">
            {{this.getLanguageItem['ShopUi']['buttonAddToCart']}}
          </b-button>
          <div v-if="submitError != undefined" v-html="submitError"></div>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import ShopVoucherTemplateSelector from "@/components/ShopVoucherTemplateSelector";
import ShopVoucherTemplatePreview from "@/components/ShopVoucherTemplatePreview";
import ShopVoucherCustomMessageForm from "@/components/ShopVoucherCustomMessageForm";
import ShopVoucherDescriptionPanel from "@/components/ShopVoucherDescriptionPanel";
import ShopVoucherServiceSelection from "@/components/ShopVoucherServiceSelection";

export default {
  name: "ShopVoucherView",
  components: {
    ShopVoucherTemplateSelector,
    ShopVoucherTemplatePreview,
    ShopVoucherCustomMessageForm,
    ShopVoucherDescriptionPanel,
    ShopVoucherServiceSelection,
  },
  data() {
    return {
     /*  selectedTemplate: undefined, */
      panelData: [],
      submitError: undefined,
    };
  },
  methods: {
    async loadProductFromServer(productId) {
      let config = {
        header: this.$store.getters.getRestHeader,
        params: {
          productId: productId,
          imageSize: "medium" /* small, medium, big */,
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
        }
      };

      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/productDetail", config)
        .then(response => {
         // console.log("GET productDetail: " + response.status, response.data);
          //console.log(response.data);

          // add properties we need later for counting and prices
          response.data.count = 1;
          response.data.selectedTemplate = undefined;
          response.data.customText = '';
          response.data.requestShipping = false;
          // fix GroupPerson
          if (response.data.personGroups) {
            response.data.personGroups.forEach(g => {
              // add count and sum to cachedObject
              g.count = 0;
              g.index = 0;
            });
          }

          if(response.data.voucherType=='fixedPrice'){
            response.data.count = 1;
          }

          // fix List
          if (response.data.prices) {
            response.data.prices.forEach(p => {
              p.count = 0;
            });
          }

          if(response.data.voucherType=='variablePrice'){
            response.data.count = response.data.minimumPrice; // set minimum price
          }

          // add to cached Items
          this.$store.dispatch("updateCachedItems", response.data);

          // use cached item from here on
          this.panelData = this.$store.getters.getCachedItemById(this.getSelectedItemId);
        })
        .catch(err => {
          console.log("GET productDetail ERROR: ", err);
          this.panelData = {};
        });
    },
    addToCart(){
     // console.log('add to cart:', this.getSelectedItem);
      // we need to check the item before we can send it to the cart
      if(this.getSelectedItem.count <= 0){
        console.log('No Item count?');
        // TODO: Visual Error
        this.submitError = '<p class="mt-3 text-warning">Bitte wählen Sie einen Betrag. </p>';

        return;
      }

      let data = {
              productId:    this.getSelectedItem.id,
              productType:  this.getSelectedItem.type,
              count:        this.getSelectedItem.count,
              requestShipping: this.getSelectedItem.requestShipping, //
      };

      // if there are no TEMPLATES, we can't use any!
      // also select first if nothing was set by user
      if(this.getSelectedItem.imageTemplates != undefined && this.getSelectedItem.imageTemplates.length > 0){
        if(this.getSelectedItem.selectedTemplate == undefined){
          // what are we doing if there was no template selected ? use first? FIXME
          this.getSelectedItem.selectedTemplate = this.getSelectedItem.imageTemplates[0];
          //console.log('No Template selected, using first available Template: ', this.getSelectedItem.selectedTemplate);
        }

        // set TEMPLATE
        data.templateId = this.getSelectedItem.selectedTemplate.id;
      }

      // allowCustomText ?
      if(this.getSelectedItem.allowCustomText){
        data.customText = this.getSelectedItem.customText;
      }

      // set values for specific voucherTypes
      switch (this.getSelectedItem.voucherType) {
        case 'priceList':
         // console.log('Add Pricelist2: ');
          data.selectedPrice = this.getSelectedItem.selectedPrice;
          data.count=1;
          break;
        case 'personGroupPrices':
         // console.log('Add personGroupPrices: ');
          data.personGroups = [];
          this.getSelectedItem.personGroups.forEach(element => {

            data.personGroups.push({
              id: element.id,
              numberOfPersons: element.prices[element.index].numberOfPersons
            });

          });

          break;
        case 'variablePrice':
         // console.log('Add variablePrice: ');
          // nothing else to add
          data.selectedPrice = this.getSelectedItem.count;

          data.count = 1;
          break;
        case 'fixedPrice':
         // console.log('Add fixedPrice: ');
          // nothing else to add
          break;
        default:
          break;
      }

     // console.log('Basket to send: ', data);

      this.postAddToBasket(data);
    },
    async postAddToBasket(params) {

      let config = this.$store.getters.getRestHeaderConfig;
      config.params = undefined; // make sure they are empty

      //console.log('POST addToBasket:', params, config);

      await this.$http
        .post(this.$store.getters.getRestServerBaseUrl + "/addToBasket", params , config)
        .then(response => {
         // console.log("POST postAddToBasket response: "  + response.status, response.data);

        // save response to store
        this.$store.dispatch('saveBasket', response.data);

        // we can show the CART now
        this.$router.push('/app/cart');

        })
        .catch(err => {
          console.log("POST postAddToBasket ERROR: ", err);
        });
    },
    async loadShoppingBasketFromServer() {
      let config = {
        header: this.$store.getters.getRestHeader,
        params: {
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
        }
      };

      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/basket", config)
        .then(response => {
         // console.log("GET basket: " + response.status);
          //console.log(response.data);

          // save to store
          this.$store.dispatch('saveBasket', response.data)
        //  console.log('stored new Basket: ', this.$store.getters.getBasket);


        })
        .catch(err => {
          console.log("GET basket ERROR: ", err);
          // reset basket? FIXME

        });
    },
  },
  computed: {
    getSelectedItemId: function() {
      return this.$route.params.id;
    },
    getSelectedItem: function() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    },
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getVoucherTemplatesData() {
      return {
        Label: this.getLanguageItem["ShopUi"]["selectTemplateLabel"],
        LabelClass: this.getLanguageItem["ShopUi"]["selectTemplateLabelClass"],
        shopItem: this.getSelectedItem
      };
    },
    hasTeamplatesItems() {
      if (this.getSelectedItem.imageTemplates != undefined && this.getSelectedItem.imageTemplates.length > 1) {
        return true;
      } else {
        return false;
      }
    },
    isCustomTextEnabled(){
      if(this.getSelectedItem.allowCustomText != undefined && this.getSelectedItem.allowCustomText != false){
        return true;
      }else{
        return false;
      }
    },
    itemShipping__(){
      return this.getSelectedItem.requestShipping;
    }
  },
  beforeMount() {
    // console.log("selected Item ID: " + this.getSelectedItemId + " loading ...");

    this.loadProductFromServer(this.getSelectedItemId);
  },
  mounted(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  },
};
</script>

